import React from "react";
import { apiUrls } from "../../../actprep-ui/utils/urls";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ContentBox from "../../../actprep-ui/components/ContentBox";
import PaginatedTable from "../../../actprep-ui/components/PaginatedTable";
import layout from "../../../actprep-ui/constants/layout";
import { sortingModes } from "../../../actprep-ui/constants/dataGrid";
import {
  capitalize,
  format6CharCode,
} from "../../../actprep-ui/utils/formatting";
import MockACTEventForm from "../../../components/MockACTEventForm";

export default function MockACTEvents() {
  const mockActEventColumns = () => [
    {
      field: "title",
      headerName: "Title",
      width: 200,
    },
    {
      field: "code",
      headerName: "Code",
      valueFormatter: format6CharCode,
      width: 100,
    },
    {
      field: "event_type",
      headerName: "Type",
      valueFormatter: (val) => val?.split("-").map(capitalize).join(" "),
      width: 100,
    },
    {
      field: "event_dt",
      headerName: "Date/Time",
      type: "dateTime",
      width: 250,
      valueGetter: (val) => (val ? new Date(val) : null),
    },
    {
      field: "school",
      headerName: "School",
      valueGetter: (val) => val?.name,
      width: 200,
    },
    {
      field: "test",
      headerName: "Test",
      valueGetter: (val) => val?.name,
      width: 200,
    },
    {
      field: "testing_type",
      headerName: "Test Type",
      valueFormatter: (val) => val?.split("-").map(capitalize).join(" "),
      width: 150,
    },
    {
      field: "subject",
      headerName: "Subject",
      valueFormatter: capitalize,
      width: 150,
    },
    {
      field: "full_test_count",
      headerName: "Full Tests",
      width: 100,
    },
    {
      field: "subject_test_count",
      headerName: "Subject Tests",
      width: 110,
    },
  ];

  return (
    <Grid
      sx={{
        marginTop: `${layout.navBarHeight + 1}rem`,
      }}
      size={12}
    >
      <ContentBox style={{ maxHeight: "80vh", height: "500rem" }}>
        <Typography variant="h5" fontWeight={"bold"}>
          Mock ACT Events
        </Typography>
        <Box sx={{ height: "90%" }}>
          <PaginatedTable
            searchable
            tableName={"Mock ACT Events"}
            apiUrl={apiUrls.admin.mockActEvents()}
            columns={mockActEventColumns}
            urlParams={{
              keep_related: "true",
            }}
            sortingMode={sortingModes.SERVER}
            disableCellFocus
            getRowTitle={({ row }) => row?.title}
            // EditForm={MockACTEventForm}
            CreationForm={MockACTEventForm}
            addRowButtonText="Add Event"
          />
        </Box>
      </ContentBox>
    </Grid>
  );
}
